import { render, staticRenderFns } from "./reports-template.vue?vue&type=template&id=8c3270f8&scoped=true"
import script from "./reports-template.vue?vue&type=script&lang=js"
export * from "./reports-template.vue?vue&type=script&lang=js"
import style0 from "./reports-template.vue?vue&type=style&index=0&id=8c3270f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3270f8",
  null
  
)

export default component.exports